<template>
  <ReportDesigner />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
